{
  "name": "fibii",
  "version": "3.122.1",
  "engines": {
    "node": "22"
  },
  "packageManager": "yarn@4.9.1",
  "scripts": {
    "ng": "ng",
    "ng-with-env-staging": "DOTENV_CONFIG_PATH=src/environments/.env.build.local node -r dotenv/config ./node_modules/.bin/ng",
    "copy-local-assets": "mkdir -p src/assets/flags && cp -R node_modules/flag-icons/flags/ src/assets/flags ",
    "dev": "yarn start",
    "start": "yarn generate:sprite && yarn copy-local-assets && yarn ng-with-env-staging serve --configuration=staging",
    "start:it": "yarn generate:sprite && yarn copy-local-assets && yarn ng-with-env-staging serve --configuration=it",
    "start:es": "yarn generate:sprite && yarn copy-local-assets && yarn ng-with-env-staging serve --configuration=es",
    "build": "yarn ng run fibii:build:staging",
    "build:app:fr": "yarn generate:sprite && BUILD_LOCALE=fr_FR BUILD_LANG=fr ng run fibii:build --delete-output-path=false --deploy-url=https://cdn.wizbii.io/fibii/$CI_COMMIT_SHA/fr/",
    "build:app:it": "yarn generate:sprite && BUILD_LOCALE=it_IT BUILD_LANG=it ng run fibii:build:it --delete-output-path=false --deploy-url=https://cdn.wizbii.io/fibii/$CI_COMMIT_SHA/it/",
    "build:app:es": "yarn generate:sprite && BUILD_LOCALE=es_ES BUILD_LANG=es ng run fibii:build:es --delete-output-path=false --deploy-url=https://cdn.wizbii.io/fibii/$CI_COMMIT_SHA/es/",
    "build:app": "yarn generate:sprite && yarn ng run fibii:build",
    "start:ssr": "yarn ng-with-env-staging run fibii:build:staging && yarn ng-with-env-staging run fibii:ssr-server:staging && DOTENV_CONFIG_PATH=src/environments/.env.runtime.local node -r dotenv/config dist/server/main.js",
    "start:dist": "PORT=4201 DOTENV_CONFIG_PATH=src/environments/.env.runtime.local node -r dotenv/config dist/server/main.js",
    "build:ssr": "yarn build:ssr:server",
    "build:ssr:app:fr": "BUILD_LOCALE=fr_FR BUILD_LANG=fr yarn build:ssr:app",
    "build:ssr:server": "yarn ng run fibii:ssr-server && cp -R ./server/assets ./dist/server",
    "test": "jest --maxWorkers=50%",
    "test:ci": "yarn test --ci --coverage",
    "fix:lint": "run-p -c \"lint:ts --fix\" \"lint:pretty --write\"",
    "lint": "run-p -c 'lint:*'",
    "lint:ts": "yarn ng lint",
    "eslint:ci": "yarn ng lint",
    "lint:scss": "stylelint --cache --cache-strategy metadata 'src/**/*.scss'",
    "stylelint:ci": "stylelint --cache --cache-strategy metadata 'src/**/*.scss'",
    "lint:pretty": "prettier --write --cache --cache-strategy metadata --cache-location './.prettiercache' 'src/**/*.{ts,scss,js,json,yml,md,html}'",
    "prettier:ci": "prettier --write --cache --cache-strategy metadata --cache-location './.prettiercache' 'src/**/*.{ts,scss,js,json,yml,md,html}'",
    "format": "prettier --write --cache --cache-strategy metadata --cache-location './.prettiercache' 'src/**/*.{ts,scss,js,json,yml,md,html}'",
    "generate:sprite": "svg2sprite src/assets/svg src/assets/sprite.svg",
    "prepare": "husky install",
    "release": "release-it",
    "e2e": "npx playwright test",
    "find-deadcode": "knip",
    "unused-css": "./node_modules/.bin/ngx-unused-css > out 2>errors.txt || true",
    "postinstall": "husky",
    "i18n:extract": "ng extract-i18n --format=xlf --output-path src/locales --out-file money.xlf --progress",
    "storybook": "yarn generate:sprite && cp -r src/assets .storybook/public && ng run fibii:storybook",
    "build-storybook": "yarn generate:sprite && \\cp -r src/assets .storybook/public && ng run fibii:build-storybook"
  },
  "prettier": "@wizbii-tooling/prettier-config",
  "private": true,
  "resolutions": {
    "webpack": "^5",
    "@angular-devkit/build-angular@npm:^19.0.0": "patch:@angular-devkit/build-angular@npm%3A19.2.4#~/.yarn/patches/@angular-devkit-build-angular-npm-19.2.4-cc2a3111c5.patch"
  },
  "dependencies": {
    "@angular/animations": "~19.2.3",
    "@angular/cdk": "~19.2.6",
    "@angular/common": "~19.2.3",
    "@angular/compiler": "~19.2.3",
    "@angular/core": "~19.2.3",
    "@angular/forms": "~19.2.3",
    "@angular/material": "~19.2.6",
    "@angular/platform-browser": "~19.2.3",
    "@angular/platform-browser-dynamic": "~19.2.3",
    "@angular/platform-server": "~19.2.3",
    "@angular/router": "~19.2.3",
    "@angular/ssr": "~19.2.4",
    "@bugsnag/js": "^8.2.0",
    "@bugsnag/plugin-angular": "^8.3.0",
    "@ngrx/operators": "^19.0.1",
    "@ngrx/router-store": "^19.0.1",
    "@ngrx/store": "^19.0.1",
    "@ngrx/store-devtools": "^19.0.1",
    "@splidejs/splide": "^4.1.4",
    "@wizbii-components/angular-styles": "^5.18.1",
    "@wizbii-components/angular-ui": "^5.18.1",
    "@wizbii-components/styles": "^5.18.1",
    "@wizbii-money/angular": "^6.6.1",
    "@wizbii-money/styles": "^6.6.1",
    "@wizbii-money/tailwindcss": "^6.4.0",
    "@wizbii-node/utils": "^5.1.0",
    "@wizbii-utils/angular": "^4.36.1",
    "@wizbii/media": "^3.43.13",
    "@wizbii/ngx-scroll-to": "^16.0.0",
    "@wizbii/styles": "^13.8.0",
    "@wizbii/utils": "^4.36.1",
    "adler-32": "^1.3.1",
    "algoliasearch": "^5.22.0",
    "body-parser": "^1.20.3",
    "canvas-confetti": "1.9.3",
    "cookie-parser": "^1.4.7",
    "dayjs": "^1.11.13",
    "deep-equal": "^2.2.3",
    "embla-carousel-angular": "^19.0.0",
    "embla-carousel-fade": "^8.5.2",
    "express": "^4.21.2",
    "hammerjs": "^2.0.8",
    "marked": "^14.1.3",
    "ngx-cookie-service": "^19.1.2",
    "ngx-markdown": "^19.1.1",
    "ngx-pipes": "^3.2.2",
    "ngx-quicklink": "0.4.7",
    "ngx-skeleton-loader": "^11.0.0",
    "ngx-splide": "^7.0.1",
    "ngxtension": "^5.0.0",
    "normalize.css": "^8.0.1",
    "prom-client": "^15.1.3",
    "query-string": "^9.1.1",
    "rxjs": "^7.8.2",
    "tailwind-merge": "^3.0.2",
    "tslib": "^2.8.1",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-builders/custom-esbuild": "19.0.0",
    "@angular-builders/custom-webpack": "19.0.0",
    "@angular-devkit/build-angular": "patch:@angular-devkit/build-angular@npm%3A19.2.4#~/.yarn/patches/@angular-devkit-build-angular-npm-19.2.4-cc2a3111c5.patch",
    "@angular/cli": "~19.2.4",
    "@angular/compiler-cli": "~19.2.3",
    "@angular/localize": "19.2.3",
    "@bugsnag/angular-performance": "^2.7.1",
    "@bugsnag/browser-performance": "^2.11.0",
    "@playwright/test": "^1.51.1",
    "@release-it/conventional-changelog": "^10.0.0",
    "@storybook/addon-designs": "^8.2.1",
    "@storybook/addon-essentials": "^8.6.9",
    "@storybook/addon-interactions": "^8.6.9",
    "@storybook/angular": "^8.6.9",
    "@storybook/blocks": "^8.6.9",
    "@storybook/test": "^8.6.9",
    "@tailwindcss/postcss": "^4.0.15",
    "@tailwindcss/typography": "^0.5.16",
    "@types/body-parser": "^1.19.5",
    "@types/canvas-confetti": "^1.9.0",
    "@types/cookie-parser": "^1.4.8",
    "@types/express": "^4.17.21",
    "@types/jest": "^29.5.14",
    "@types/node": "~22.13.13",
    "@types/webpack-bugsnag-plugins": "^1.4.5",
    "@wizbii-tooling/commitlint-config": "^6.1.0",
    "@wizbii-tooling/eslint-config-angular": "^6.1.0",
    "@wizbii-tooling/prettier-config": "6.2.0",
    "@wizbii-tooling/stylelint-config-scss": "6.1.0",
    "@wizbii/ngx-unused-css": "^4.0.2",
    "@wizbii/svg2sprite-cli": "^2.1.0",
    "autoprefixer": "^10.4.21",
    "commitlint": "^19.8.0",
    "dotenv": "^16.4.7",
    "esbuild-plugin-environment": "^0.4.0",
    "eslint": "^8",
    "eslint-plugin-storybook": "^0.11.6",
    "husky": "^9.1.7",
    "jest": "^29.7.0",
    "knip": "^5.46.0",
    "ng-mocks": "^14.13.4",
    "npm-run-all": "^4.1.5",
    "postcss": "^8.5.3",
    "prettier": "^3.5.3",
    "release-it": "^17.11.0",
    "storybook": "^8.6.9",
    "stylelint": "16.16.0",
    "tailwindcss": "4.1.4",
    "ts-jest": "^29.3.0",
    "ts-loader": "^9.5.2",
    "tsconfig-paths-webpack-plugin": "^4.2.0",
    "type-fest": "^4.38.0",
    "typescript": "~5.7.3",
    "webpack-bugsnag-plugins": "^1.9.0"
  }
}
